import Vue from "vue";
import axios from "axios";
import "../../filters";
import moment from "moment";
import users from "../../users";
import localDataFunctions from "@/localDataFunctions";

const edams_controls_tpl = {
  page: "csApplications_employee",

  controls: {
    sectionFilters: { employee: { visible: true, disabled: false } },
    sectionList: { employee: { visible: true, disabled: false } },
  },
};

const pickerDateFormat = "YYYY-M-D";
const uiDateFormat = "DD/MM/YYYY";

export default {
  name: "Applications",
  mixins: [users, localDataFunctions],
  components: {
    //DataGridComp: require('../../customcontrols/datagrid.vue').default,
    //CompDataGridComp: require('../../customcontrols/datagrid.vue').default,
    //EmpDataGridComp: require('../../customcontrols/datagrid.vue').default,

    EmpDataGridComp:
      require("@/customcontrols/applicationsDataGrid/applicationsDataGrid.vue")
        .default,
    DataGridComp:
      require("@/customcontrols/applicationsDataGrid/applicationsDataGrid.vue")
        .default,
    CompDataGridComp:
      require("@/customcontrols/applicationsDataGrid/applicationsDataGrid.vue")
        .default,

    GoogleMapElementComp: require("../../components/maps/gMapElement.vue")
      .default,
    MapComp: require("../../components/maps/map.vue").default,
    OfflineMode: require("../../common/offline/offline.vue").default,
    HierarchyLinksComp:
      require("../../common/hierarchyLinks/hierarchyLinks.vue").default,
    reportsComp: require("../../common/reports/reports.vue").default,
  },
  data: function () {
    return {
      billingGroup: null,
      billingGroups: [],
      priority: null,
      prioritys: [],
      assignToEmployee: null,
      assignToEmployees: [],
      sourceType: null,
      sourceTypes: [],

      expandOffline: false,
      createNewAppEnabled: false,
      currentTab: "tab-empApps",
      isUserFieldWorker: true,
      firstLoad: true,
      edams_controls: edams_controls_tpl.controls,
      bShowSecurities: false,
      gMapData: {
        latitude: -25.476418549935577,
        longitude: 30.97445231420286,
      },
      apps: [],
      employeeApps: [],
      completedApps: [],
      elementTypes: [],
      elements: [],
      elementType: {
        gisLayerName: "",
        moduleId: "",
        name: "",
        typeId: 0,
      },
      bGPSFiltering: false,
      bQrCodeScan: false,
      element: {
        externalRef: "",
        id: 0,
        name: "",
        typeId: 0,
      },
      message: "",
      showFilters: false,
      isOm: false,
      search: "",
      optionsElement: { pageSize: 1000, total: 0, page: 1, count: 0 },
      options: { pageSize: 1000, total: 0, page: 1, from: null, to: null },
      empAppsOptions: {
        pageSize: 1000,
        total: 0,
        page: 1,
        from: null,
        to: null,
      },
      CompletedAppsOptions: {
        pageSize: 1000,
        total: 0,
        page: 1,
        from: null,
        to: null,
      },
      assignedToEmployee: false,
      externalTask: true,
      totalRow: 0,
      totalEmpAppsRow: 0,

      totalCompletedRow: 0,

      editButtons: [
        {
          hint: "Edit",
          icon: "edit",
          visible: true,
          onClick: this.editApp,
        },
      ],
      filterBuilderPopupPosition: {
        of: window,
        at: "top",
        my: "top",
        offset: { y: 10 },
      },
      bAutoExpand: true,

      appsCols: [],
      employeeAppsCols: [],
      completedAppsCols: [],
      keyColumn: "applicationId",

      applicationStatus: -1,
      applicationStatuses: [],
      applicationCancelReasons: [],
      applicationCancelReason: {
        id: 0,
        text: "",
      },
      employees: [],
      employee: {
        disabled: false,
        group: null,
        selected: true,
        text: "All",
        value: "-1",
      },
      serviceTypes: [],
      serviceType: {
        disabled: false,
        group: null,
        selected: true,
        text: "All",
        value: "-1",
      },
      stations: [],
      station: {
        disabled: false,
        group: null,
        selected: true,
        text: "All",
        value: "-1",
      },
      statuses: [],
      status: {
        disabled: false,
        group: null,
        selected: true,
        text: "All",
        value: "-1",
      },
      showReportsDialog: false,
      reports: [],
      queries: [],
      bConfirmResetDialog: false,
      bConfirmSyncDialog: false,

      selectionMode: "multiple",
      selectedApps: [],
      offlineAppIds: [],
      offlineApps: [],

      offlineSavedApps: [],
      removeSyncRecordConfirmation: false,
      syncRecord: null,
      hierarchyLinksOptions: {
        dnd: false,
        checkbox: false,
        /*propertyNames: {
          text: 'Name',
          children: 'Children',
          elementId: 'ElementId',
          elementTypeId: 'ElementTypeId'
        },*/
      },
      hierarchyLinksItems: [],
      renderKey: 0,
      treeIdx: 0,
      HierarchyKey: 0,
      hierarchyLinks: [],

      appsCol: null,
      treeCol: null,

      selectedNode: null,
      showTree: false,

      customColumns: {},
      filterByApplicationDomain: true,
      applicationStation: -1,
      orgPosts: [],
      applicationOrgPost: -1,
      empAppsAssignToEmpFilter: false,

      HierarchyLinksCompLoaded: false,
      employeeStationId: -1,
    };
  },
  computed: {
    formattedFromDate: function () {
      return this.formatDateUI(moment(this.fromDate));
    },
    formattedToDate: function () {
      return this.formatDateUI(moment(this.toDate));
    },
    fromDate: function () {
      return this.options.from;
    },
    toDate: function () {
      return this.options.to;
    },
    offlineModeState: function () {
      return this.$store.state.csAppsOfflineMode;
    },
    gridSelectionMode: function () {
      if (!this.expandOffline) return "single";

      return this.$store.state.csAppsOfflineMode ||
        !this.$store.state.enableOfflineApplications
        ? "single"
        : "multiple";
    },
  },
  watch: {
    elementType: function (value) {
      if (!value) return;
      this.getElements();
    },
    offlineModeState: function (value) {
      if (value) {
        this.getOfflineApplications();
      } else {
        this.$router.go(this.$router.currentRoute);

        //this.isOm = this.$route.name === 'omActivities';

        //this.getLookups();
        //this.getApplications();
        //this.getEmployeeApplications();
        //this.getCompletedApplications();
      }
    },
    assignedToEmployee: function (value) {
      this.$localStorage.set("_assignedToEmployee", value);
    },
    empAppsAssignToEmpFilter: function (value) {
      this.getEmployeeApplications();
    },
  },
  mounted() {
    this.applyWatcher();

    this.appsCol = document.querySelector(".apps-col");
    this.treeCol = document.querySelector(".tree-col");

    let sett = this.$store.getters.getUserProfile;
    if (sett && !sett.isFieldWorker) {
      this.isUserFieldWorker = false;
    }
  },
  created() {
    this.currentTab = this.getFromLocal("_selected_applications_tab");

    this.getProfileDetails().then((resp) => {
      if (resp) return;

      this.optionsElement.pageSize = 10;
      this.options.pageSize = 10;
      this.empAppsOptions.pageSize = 10;
      this.CompletedAppsOptions.pageSize = 10;
    });

    this.getEmployeeStation();
    this.$root.$on("employee_station_updated", this.getEmployeeStation);

    this.getApplicationTypes();
    if (this.$localStorage.get("_assignedToEmployee")) {
      this.assignedToEmployee =
        this.$localStorage.get("_assignedToEmployee") === "true";
    }

    if (this.$store.state.csAppsOfflineMode) {
      this.apps = this.$store.state.offlineApplicationsData.appViews;

      this.options.total = this.apps.length;
    } else {
      this.isOm = this.$route.name === "omActivities";

      this.fillApplicationsColumns();
      this.readSecurities(edams_controls_tpl.page, this.edams_controls);
      this.options.to = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      );
      this.options.from = this.addMonths(this.options.to, -1);

      this.getLookups();

      if (this.isOm) {
        this.getElementTypes();
      }

      this.getGeneralReports();
      this.getQueries();
    }

    this.getOfflineAllRecords();

    this.expandOffline = this.getFromLocal("applications_offline_pref") ?? true;
  },
  methods: {
    async getProfileDetails() {
      return await axios
        .post("/account/GetProfileDetails")
        .then((response) => {
          this.isUserFieldWorker = response.data.item.isFieldWorker;
          return this.isUserFieldWorker;
        })
        .catch((err) => {
          this.isUserFieldWorker = true;
          return this.isUserFieldWorker;
        });
    },
    openCloseOffline() {
      this.expandOffline = !this.expandOffline;
      this.saveToLocal("applications_offline_pref", this.expandOffline);
    },
    getApplicationTypes() {
      let om = this.$route.name.includes("om");
      var parameter = { Module: om == true ? 2 : 1 };

      axios
        .post("/EmployeeApplication/GetApplicationTypes", parameter)
        .then((resp) => {
          if (
            resp.status === 200 &&
            resp.data.data.status == 0 &&
            resp.data.items.length > 0
          )
            this.createNewAppEnabled = true;
          else this.createNewAppEnabled = false;
        })
        .catch((err) => (this.createNewAppEnabled = false));
    },
    calculateCellClass(value) {
      return value.data.problemStatusVal === 0
        ? "recordTypeOrange"
        : value.data.problemStatusVal === 1
        ? "recordTypeGray"
        : value.data.problemStatusVal === 2
        ? "recordTypeBlack"
        : value.data.problemStatusVal === 3
        ? "recordTypeTeal"
        : value.data.problemStatusVal === 4
        ? "recordTypeBlue"
        : value.data.problemStatusVal === 5
        ? "recordTypeGreen"
        : "recordTypePurple";
    },
    applyWatcher() {
      //this.$watch('search', function (newVal, oldVal) {
      //  this.getApplications();
      //});
      //this.$watch('assignedToEmployee', function (newVal, oldVal) {
      //  this.getApplications();
      //});
      //this.$watch('externalTask', function (newVal, oldVal) {
      //  this.getApplications();
      //});
      //this.$watch('fromDate', function (newVal, oldVal) {
      //  this.getApplications();
      //});
      //this.$watch('toDate', function (newVal, oldVal) {
      //  this.getApplications();
      //});
      //this.isLoadCompleted = true;
    },
    manageSecurities(event) {
      this.bShowSecurities = !this.bShowSecurities;
      if (this.bShowSecurities === true)
        this.showSecurities(this.edams_controls);
      else this.readSecurities(edams_controls_tpl.page, this.edams_controls);
    },
    dateIdCompareDesc(a, b) {
      return (
        new Date(b.date).getTime() - new Date(a.date).getTime() &&
        b.applicationId - a.applicationId
      );
    },
    pageChange(pInfo) {
      if (
        pInfo.pageNumber == this.options.page &&
        pInfo.pageSize == this.options.pageSize
      )
        return;

      for (var i = 0; i < this.selectedApps.length; i++) {
        if (
          this.offlineAppIds.filter(
            (a) => a == this.selectedApps[i].applicationId
          ).length == 0
        )
          this.offlineAppIds.push(this.selectedApps[i].applicationId);
      }

      this.options.page = pInfo.pageNumber;
      //pInfo.pageSize = this.options.pageSize;
      this.options.pageSize = pInfo.pageSize;
      //var parameters = { PageSize: pInfo.pageSize, Page: pInfo.pageNumber, FilterText: this.search, From: this.options.from, To: this.options.to, AssignedToEmployee: this.assignedToEmployee, ExternalTask: this.externalTask };

      this.getApplicationsAux();
    },
    clearFilters() {
      this.applicationOrgPost = -1;
      this.applicationStation = -1;
      this.applicationStatus = -1;
      this.search = "";
      this.billingGroup = "";
      this.priority = -1;
      this.assignToEmployee = -2;
      this.sourceType = 0;
      this.options.to = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      );
      this.options.from = this.addMonths(this.options.to, -1);
      this.externalTask = true;

      this.station = {
        disabled: false,
        group: null,
        selected: true,
        text: "All",
        value: "-1",
      };
      this.employee = {
        disabled: false,
        group: null,
        selected: true,
        text: "All",
        value: "-1",
      };
      this.serviceType = {
        disabled: false,
        group: null,
        selected: true,
        text: "All",
        value: "-1",
      };
      this.status = {
        disabled: false,
        group: null,
        selected: true,
        text: "All",
        value: "-1",
      };
      this.element = {
        name: "All",
        value: "-1",
      };
      this.elementType = {
        disabled: false,
        group: null,
        selected: true,
        text: "All",
        value: "-1",
      };

      this.getApplications();
      this.getEmployeeApplications();
      this.getCompletedApplications();
    },
    getApplicationsAux(scrollToApps) {
      if (this.offlineModeState) return;

      var parameters = {
        PageSize: this.options.pageSize,
        Page: this.options.page,
        FilterText: this.showFilters ? this.search : "",
        From: this.showFilters
          ? moment(this.options.from, "DD/MM/YYYY").add(1, "days")
          : null,
        To: this.showFilters
          ? moment(this.options.to, "DD/MM/YYYY").add(1, "days")
          : null,
        AssignedToEmployee: this.assignedToEmployee,
        ApplicationStatus: this.showFilters ? this.applicationStatus : null,
        ApplicationTypeModule: 1,
        StationId:
          this.stations.length == 0
            ? null
            : this.stations.filter((a) => a.selected == true).length == 0
            ? null
            : this.stations.filter((a) => a.selected == true)[0].value != -1
            ? this.stations.filter((a) => a.selected == true)[0].value
            : "",
        ElementId: this.element.id > 0 ? this.element.id : null,
        ElementType:
          this.elementType.typeId > 0 ? this.elementType.typeId : null,
        EmployeeId:
          parseInt(this.employee.value) > -1
            ? parseInt(this.employee.value)
            : null,
        ServiceTypeId:
          parseInt(this.serviceType.value) > -1
            ? parseInt(this.serviceType.value)
            : null,
        CallerLogStatusId:
          parseInt(this.status.value) > -1 ? parseInt(this.status.value) : null,
        FilterByApplicationDomain: this.filterByApplicationDomain,
        OrgPostId:
          this.applicationOrgPost && this.applicationOrgPost > -1
            ? this.applicationOrgPost
            : null,
        DisableOrgPostAccessCheck: true,

        BillingGroup: this.showFilters ? this.billingGroup : null,
        PriorityId: this.showFilters ? this.priority : null,
        AssignedEmployeeId: this.showFilters ? this.assignToEmployee ?? -1 : -1,
        ApplicationSourceType: this.showFilters ? this.sourceType ?? 0 : 0,
      };

      if (this.isOm === true) {
        parameters.ApplicationTypeModule = 2;
        parameters.StationId =
          this.showFilters && this.station.value !== "-1"
            ? this.station.value
            : null;
        parameters.EmployeeId =
          this.showFilters && this.employee.value !== "-1"
            ? this.employee.value
            : null;
        parameters.ServiceTypeId =
          this.showFilters && this.serviceType.value !== "-1"
            ? this.serviceType.value
            : null;
        parameters.CallerLogStatusId =
          this.showFilters && this.status.value !== "-1"
            ? this.status.value
            : null;
      }

      axios
        .post("/EmployeeApplication/GetApplications", parameters)
        .then((response) => {
          if (response.status == 200) {
            response.data.items.forEach((item) => {
              item.issueTime =
                item.date != null && item.date != ""
                  ? moment(item.date).format("HH:mm:ss")
                  : "";
              item.issueDate = item.date;
              item.lastEditTime =
                item.lastEditDate != null && item.lastEditDate != ""
                  ? moment(item.lastEditDate).format("HH:mm:ss")
                  : "";
              item.assignTime =
                item.assignDate != null && item.assignDate != ""
                  ? moment(item.assignDate).format("HH:mm:ss")
                  : "";

              let dte = moment(item.completeDate);
              if (dte.isValid()) item["completeTime"] = dte.format("hh:mm");
            });

            this.apps = response.data.items.sort(this.dateIdCompareDesc);
            this.customColumns = response.data.customColumns;
            this.firstLoad = false;
            this.options.total = response.data.itemsCount;
            this.totalRow = response.data.itemsCount;

            this.clearGridSelections();
            this.addCustomColumns();

            if (scrollToApps) this.$scrollToElement("applications_grids");

            setTimeout(() => {
              if (this.$refs.applicationsGrid)
                this.$refs.applicationsGrid.resetColumns();
            }, 10000);
          }
        })
        .catch(this.getApplicationErrorHandling);
    },
    getApplications(scrollToApps) {
      if (this.offlineModeState) return;

      var parameters = {
        PageSize: this.options.pageSize,
        Page: this.options.page,
        FilterText: this.showFilters ? this.search : "",
        From: this.showFilters
          ? moment(this.options.from, "DD/MM/YYYY").add(1, "days")
          : null,
        To: this.showFilters
          ? moment(this.options.to, "DD/MM/YYYY").add(1, "days")
          : null,
        AssignedToEmployee: this.assignedToEmployee,
        ApplicationStatus: this.showFilters ? this.applicationStatus : null,
        ApplicationTypeModule: 1,
        StationId: this.applicationStation != -1 ? this.applicationStation : "",
        ElementId: this.element.id > 0 ? this.element.id : null,
        ElementType:
          this.elementType.typeId > 0 ? this.elementType.typeId : null,
        FilterByLink:
          this.element.id > 0 &&
          this.$store.state.settings.omFilterAppsByWholeBranch
            ? true
            : false,
        EmployeeId:
          parseInt(this.employee.value) > -1
            ? parseInt(this.employee.value)
            : null,
        ServiceTypeId:
          parseInt(this.serviceType.value) > -1
            ? parseInt(this.serviceType.value)
            : null,
        CallerLogStatusId:
          parseInt(this.status.value) > -1 ? parseInt(this.status.value) : null,
        FilterByApplicationDomain: this.filterByApplicationDomain,
        OrgPostId:
          this.applicationOrgPost && this.applicationOrgPost > -1
            ? this.applicationOrgPost
            : null,
        DisableOrgPostAccessCheck: true,

        BillingGroup: this.showFilters ? this.billingGroup : null,
        PriorityId: this.showFilters ? this.priority : null,
        AssignedEmployeeId: this.showFilters ? this.assignToEmployee ?? -1 : -1,
        ApplicationSourceType: this.showFilters ? this.sourceType ?? 0 : 0,
      };

      if (this.isOm === true) {
        parameters.ApplicationTypeModule = 2;
        parameters.StationId =
          this.showFilters && this.station.value !== "-1"
            ? this.station.value
            : null;
        parameters.EmployeeId =
          this.showFilters && this.employee.value !== "-1"
            ? this.employee.value
            : null;
        parameters.ServiceTypeId =
          this.showFilters && this.serviceType.value !== "-1"
            ? this.serviceType.value
            : null;
        parameters.CallerLogStatusId =
          this.showFilters && this.status.value !== "-1"
            ? this.status.value
            : null;
      }

      axios
        .post("/EmployeeApplication/GetApplications", parameters)
        .then((response) => {
          if (response.status == 200) {
            response.data.items.forEach((item) => {
              item.issueTime =
                item.date != null && item.date != ""
                  ? moment(item.date).format("HH:mm:ss")
                  : "";
              item.issueDate = item.date;
              item.lastEditTime =
                item.lastEditDate != null && item.lastEditDate != ""
                  ? moment(item.lastEditDate).format("HH:mm:ss")
                  : "";
              item.assignTime =
                item.assignDate != null && item.assignDate != ""
                  ? moment(item.assignDate).format("HH:mm:ss")
                  : "";

              let dte = moment(item.completeDate);
              if (dte.isValid()) item["completeTime"] = dte.format("hh:mm");
            });

            this.apps = response.data.items.sort(this.dateIdCompareDesc);
            this.customColumns = response.data.customColumns;
            this.firstLoad = false;
            this.options.total = response.data.itemsCount;
            this.totalRow = response.data.itemsCount;

            this.clearGridSelections();
            this.addCustomColumns();

            if (scrollToApps) this.$scrollToElement("applications_grids");

            setTimeout(() => {
              if (this.$refs.applicationsGrid)
                this.$refs.applicationsGrid.resetColumns();
            }, 10000);
          }
        })
        .catch(this.getApplicationErrorHandling);
    },
    getApplicationErrorHandling(err) {
      if (!err.response || err.response.data == undefined)
        this.$alertMsg(`${this.$t("messages.apiRespondedWithCode")} ${err}`);
      else this.$alertMsg(err.response.data);
    },
    editApp(app) {
      let id = app.row.data.applicationId;
      var route = "/application/" + id;
      this.$router.push(route);
    },
    onPagination(args) {
      if (args.page == this.options.page && args.size == this.options.pageSize)
        return;

      this.options.page = args.page;
      this.options.pageSize = args.size;
      this.getApplications();
    },
    formatDateUI(date) {
      return moment(date).add(1, "days").format(uiDateFormat);
    },
    formatDateYYYYMMDD(date) {
      return moment(date, "YYYY-MM-DD"); //.format();
    },
    addDays(date, days) {
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + days
      );
    },
    addMonthsUTC(date, count) {
      if (date && count) {
        var m,
          d = (date = new Date(+date)).getUTCDate();

        date.setUTCMonth(date.getUTCMonth() + count, 1);
        m = date.getUTCMonth();
        date.setUTCDate(d);
        if (date.getUTCMonth() !== m) date.setUTCDate(0);
      }
      return date;
    },
    addMonths(date, count) {
      if (date && count) {
        var m,
          d = (date = new Date(+date)).getDate();

        date.setMonth(date.getMonth() + count, 1);
        m = date.getMonth();
        date.setDate(d);
        if (date.getMonth() !== m) date.setDate(0);
      }
      return date;
    },
    addApp() {
      var url =
        this.isOm === true ? "/createApplication?mod=om" : "/createApplication";
      this.$router.push(url);
    },
    onRowDblClick(info) {
      //console.log("onRowDblClick", info)

      //TBI
      //if (!info || !info.data || !info.data.assignedStationId || info.data.assignedStationId < 0 || this.employeeStationId != info.data.assignedStationId) {
      //  this.$alertMsg(this.$t('applications.stationError'), 3);
      //  return;
      //}

      if (!info.data || !info.data.applicationId) return;

      if (this.$store.state.csAppsOfflineMode) {
        this.$store.commit("selectOfflineApplication", {
          appId: info.data.applicationId,
        });
      }

      var route =
        (this.$store.state.csAppsOfflineMode
          ? "/applicationOffline/"
          : "/application/") + info.data.applicationId;
      this.$router.push(route);
    },
    fillApplicationsColumns() {
      this.appsCols = [];

      //this.appsCols.push({ dataField: 'assigneIcon', name: 'assigneIcon', caption: '', dataType: 'icon', alignment: 'center' });

      this.appsCols.push({
        dataField: "applicationId",
        name: "applicationId",
        caption: this.$t("ApplicationsGrid.appId"),
      });
      this.appsCols.push({
        dataField: "groupName",
        name: "groupName",
        caption: this.$t("ApplicationsGrid.groupName"),
      });
      this.appsCols.push({
        dataField: "applicationTypeS",
        name: "applicationTypeS",
        caption: this.$t("ApplicationsGrid.appType"),
      });
      this.appsCols.push({
        dataField: "issueDate",
        name: "issueDate",
        caption: this.$t("ApplicationsGrid.issueDate"),
        dataType: "date",
      });
      this.appsCols.push({
        dataField: "issueTime",
        name: "issueTime",
        caption: this.$t("ApplicationsGrid.issueTime"),
        dataType: "string",
        evaluateAsTime: true,
      });
      this.appsCols.push({
        dataField: "statusDescription",
        name: "statusDescription",
        caption: this.$t("ApplicationsGrid.status"),
      });
      this.appsCols.push({
        dataField: "billGroup",
        name: "billGroup",
        caption: this.$t("ApplicationsGrid.billingGroup"),
      });
      this.appsCols.push({
        dataField: "mainCustKey",
        name: "mainCustKey",
        caption: this.$t("ApplicationsGrid.customerAccount"),
      });
      if (this.$store.state.isFieldWorker != true) {
        //console.log("added name")
        this.appsCols.push({
          dataField: "mainCustomerName",
          name: "mainCustomerName",
          caption: this.$t("ApplicationsGrid.name"),
        });
      }
      this.appsCols.push({
        dataField: "propRefS",
        name: "propRefS",
        caption: this.$t("ApplicationsGrid.propRef"),
      });
      this.appsCols.push({
        dataField: "lastActivity",
        name: "lastActivity",
        caption: this.$t("ApplicationsGrid.lastActivity"),
      });
      this.appsCols.push({
        dataField: "isSubApp",
        name: "isSubApp",
        caption: this.$t("ApplicationsGrid.subApp"),
      });
      this.appsCols.push({
        dataField: "serviceDescription",
        name: "serviceDescription",
        caption: this.$t("ApplicationsGrid.service"),
      });
      this.appsCols.push({
        dataField: "lastEditUser",
        name: "lastEditUser",
        caption: this.$t("ApplicationsGrid.lastEditUser"),
      });
      this.appsCols.push({
        dataField: "expectedComplDate",
        name: "expectedComplDate",
        caption: this.$t("ApplicationsGrid.expectedComplDate"),
        dataType: "date",
        formatData: this.$options.filters.formatDateDDMMYYY,
      });
      if (this.isOm) {
        this.appsCols.push({
          dataField: "daysElapsed",
          name: "daysElapsed",
          caption: this.$t("ApplicationsGrid.daysElapsed"),
        });
      }
      this.appsCols.push({
        dataField: "lastEditDate",
        name: "lastEditDate",
        caption: this.$t("ApplicationsGrid.lastEditDate"),
        dataType: "date",
        formatData: this.$options.filters.formatDateDDMMYYY,
      });
      this.appsCols.push({
        dataField: "lastEditTime",
        name: "lastEditTime",
        caption: this.$t("ApplicationsGrid.lastEditTime"),
        dataType: "string",
        evaluateAsTime: true,
      });
      this.appsCols.push({
        dataField: "assignedUserName",
        name: "assignedUserName",
        caption: this.$t("ApplicationsGrid.assignedUser"),
      });
      this.appsCols.push({
        dataField: "assignDate",
        name: "assignDate",
        caption: this.$t("ApplicationsGrid.assignedDate"),
        dataType: "date",
        formatData: this.$options.filters.formatDateDDMMYYY,
      });
      this.appsCols.push({
        dataField: "assignTime",
        name: "assignTime",
        caption: this.$t("ApplicationsGrid.assignedTime"),
        dataType: "string",
        evaluateAsTime: true,
      });
      this.appsCols.push({
        dataField: "priorityS",
        name: "priorityS",
        caption: this.$t("ApplicationsGrid.priority"),
      });
      this.appsCols.push({
        dataField: "createUser",
        name: "createUser",
        caption: this.$t("ApplicationsGrid.creationUser"),
      });
      this.appsCols.push({
        dataField: "address",
        name: "address",
        caption: this.$t("ApplicationsGrid.physicalAddress"),
      });
      this.appsCols.push({
        dataField: "complaintTypeS",
        name: "complaintTypeS",
        caption: this.$t("ApplicationsGrid.maintenanceComplaintType"),
      });
      this.appsCols.push({
        dataField: "complaintSubTypeS",
        name: "complaintSubTypeS",
        caption: this.$t("ApplicationsGrid.maintenanceComplaintSubType"),
      });

      if (this.isOm) {
        this.appsCols.push({
          dataField: "completeDate",
          name: "completionDate",
          caption: this.$t("ApplicationsGrid.completionDate"),
          dataType: "date",
        });
        this.appsCols.push({
          dataField: "completeTime",
          name: "completionTime",
          caption: this.$t("ApplicationsGrid.completionTime"),
          dataType: "string",
          evaluateAsTime: true,
        });
      }
      // O&M Status
      this.appsCols.push({
        dataField: "sourceApplicationIdS",
        name: "sourceApplicationIdS",
        caption: this.$t("ApplicationsGrid.sourceApplicationId"),
      });
      this.appsCols.push({
        dataField: "phaseS",
        name: "phaseS",
        caption: this.$t("ApplicationsGrid.phase"),
      });
      this.appsCols.push({
        dataField: "outcomeS",
        name: "outcomeS",
        caption: this.$t("ApplicationsGrid.outcome"),
      });
      this.appsCols.push({
        dataField: "sourceTypeS",
        name: "sourceTypeS",
        caption: this.$t("ApplicationsGrid.sourceType"),
      });
      this.appsCols.push({
        dataField: "appRef",
        name: "appRef",
        caption: this.$t("ApplicationsGrid.fileRef"),
      });
      this.appsCols.push({
        dataField: "isOverdueS",
        name: "isOverdueS",
        caption: this.$t("ApplicationsGrid.overdue"),
      });
      this.appsCols.push({
        dataField: "chargesPaidS",
        name: "chargesPaidS",
        caption: this.$t("ApplicationsGrid.chargesPaid"),
      });
      this.appsCols.push({
        dataField: "subtypeS",
        name: "subtypeS",
        caption: this.$t("ApplicationsGrid.subType"),
      });
      this.appsCols.push({
        dataField: "stationS",
        name: "stationS",
        caption: this.$t("ApplicationsGrid.station"),
      });
      this.appsCols.push({
        dataField: "townS",
        name: "townS",
        caption: this.$t("ApplicationsGrid.town"),
      });
      this.appsCols.push({
        dataField: "townshipS",
        name: "townshipS",
        caption: this.$t("ApplicationsGrid.township"),
      });
      this.appsCols.push({
        dataField: "assignedStationS",
        name: "assignedStationS",
        caption: this.$t("ApplicationsGrid.assignedStation"),
      });
      this.appsCols.push({
        dataField: "unreadMessages",
        name: "unreadMessages",
        dataType: "boolean",
        caption: this.$t("ApplicationsGrid.unreadMessages"),
      });
      this.appsCols.push({
        dataField: "licenceDate",
        name: "licenceDate",
        caption: this.$t("ApplicationsGrid.licenceDate"),
        dataType: "date",
        formatData: this.$options.filters.formatDateDDMMYYY,
      });
      this.appsCols.push({
        dataField: "licenceDueDate",
        name: "licenceDueDate",
        caption: this.$t("ApplicationsGrid.licenceDueDate"),
        dataType: "date",
        formatData: this.$options.filters.formatDateDDMMYYY,
      });
      this.appsCols.push({
        dataField: "isLicenceOverdueS",
        name: "isLicenceOverdueS",
        caption: this.$t("ApplicationsGrid.licenceOverdue"),
      });
      // Assigned to Portal
      this.appsCols.push({
        dataField: "mainApplicantPhone",
        name: "mainApplicantPhone",
        caption: this.$t("ApplicationsGrid.applicantPhone"),
      });
      this.appsCols.push({
        dataField: "reason",
        name: "reason",
        caption: this.$t("ApplicationsGrid.alertReason"),
      });
      this.appsCols.push({
        dataField: "elementTypeS",
        name: "elementTypeS",
        caption: this.$t("ApplicationsGrid.elementType"),
      });
      this.appsCols.push({
        dataField: "elementRef",
        name: "elementRef",
        caption: this.$t("ApplicationsGrid.elementRef"),
      });

      if (this.isOm) {
        this.appsCols.push({
          dataField: "invNo",
          name: "invoiceNo",
          caption: this.$t("ApplicationsGrid.invNo"),
        });
        this.appsCols.push({
          dataField: "mrNo",
          name: "mrNo",
          caption: this.$t("ApplicationsGrid.mrNo"),
        });
        this.appsCols.push({
          dataField: "jobcardNo",
          name: "jobcardNo",
          caption: this.$t("ApplicationsGrid.jobcardNo"),
        });
        this.appsCols.push({
          dataField: "problemStatusVal",
          name: "problemStatus",
          cellTemplate: "cellTemplate",
          alignment: "center",
          caption: this.$t("ApplicationsGrid.problemStatus"),
        });
        this.appsCols.push({
          dataField: "maintenanceActivityDescription",
          name: "maintenanceActivityDescription",
          caption: this.$t("ApplicationsGrid.maintenanceActivity"),
        });
        this.appsCols.push({
          dataField: "problemStreet",
          name: "problemStreet",
          caption: this.$t("ApplicationsGrid.street"),
        });
        this.appsCols.push({
          dataField: "problemHouse",
          name: "problemHouse",
          caption: this.$t("ApplicationsGrid.house"),
        });
        this.appsCols.push({
          dataField: "problemFlat",
          name: "problemFlat",
          caption: this.$t("ApplicationsGrid.flat"),
        });
        this.appsCols.push({
          dataField: "settlement",
          name: "settlement",
          caption: this.$t("ApplicationsGrid.settlement"),
        });
        this.appsCols.push({
          dataField: "originId",
          name: "originId",
          caption: this.$t("ApplicationsGrid.originId"),
        });
        this.appsCols.push({
          dataField: "description",
          name: "description",
          caption: this.$t("ApplicationsGrid.description"),
        });
        this.appsCols.push({
          dataField: "requisitionStatus",
          name: "requisitionStatus",
          caption: this.$t("ApplicationsGrid.requisitionStatus"),
        });
        this.appsCols.push({
          dataField: "jcOutcome",
          name: "jcOutcome",
          caption: this.$t("ApplicationsGrid.jobCardOutcome"),
        });
        this.appsCols.push({
          dataField: "jcComment",
          name: "jcComment",
          caption: this.$t("ApplicationsGrid.jobCardComment"),
        });
        this.appsCols.push({
          dataField: "omSourceType",
          name: "omSourceType",
          caption: this.$t("ApplicationsGrid.problemSource"),
        });
      }

      this.appsCols.filter((a) => a.dataField == "priorityS")[0][
        "priorityHighlight"
      ] = true;

      this.employeeAppsCols = JSON.parse(JSON.stringify(this.appsCols));
      this.employeeAppsCols.filter(
        (a) => a.dataField == "applicationId"
      )[0].highlight = true;

      this.completedAppsCols = JSON.parse(JSON.stringify(this.appsCols));

      this.appsCols.filter(
        (a) => a.dataField == "applicationId"
      )[0].accessHighlight = true;
      this.appsCols.filter((a) => a.dataField == "applicationId")[0][
        "stationAccessHighlight"
      ] = true;

      //for (var i = 0; i < this.appsCols.length; i++) {
      //  if (this.appsCols[i].dataField != 'statusDescription') {
      //    if (this.appsCols[i].dataField == 'assigneIcon') {
      //      this.employeeAppsCols.push(this.appsCols[i]);
      //    }
      //    else {
      //      this.employeeAppsCols.push(this.appsCols[i]);
      //      this.completedAppsCols.push(this.appsCols[i]);
      //    }

      //    if (this.appsCols[i].dataField == 'applicationId') {
      //      this.employeeAppsCols[i].highlight = true;
      //    }
      //  }
      //}

      //console.log(this.employeeAppsCols);
      //console.log(this.appsCols);
    },
    addCustomColumns() {
      if (this.customColumns.CustomColumn0 != null) {
        if (this.appsCols.filter((a) => a.name == "customColumn0").length == 0)
          this.appsCols.push({
            dataField: "customColumn0",
            name: "customColumn0",
            caption: this.customColumns.CustomColumn0,
            visible: false,
          });
      }

      if (this.customColumns.CustomColumn1 != null) {
        if (this.appsCols.filter((a) => a.name == "customColumn1").length == 0)
          this.appsCols.push({
            dataField: "customColumn1",
            name: "customColumn1",
            caption: this.customColumns.CustomColumn1,
            visible: false,
          });
      }

      if (this.customColumns.CustomColumn2 != null) {
        if (this.appsCols.filter((a) => a.name == "customColumn2").length == 0)
          this.appsCols.push({
            dataField: "customColumn2",
            name: "customColumn2",
            caption: this.customColumns.CustomColumn2,
            visible: false,
          });
      }

      if (this.customColumns.CustomColumn3 != null) {
        if (this.appsCols.filter((a) => a.name == "customColumn3").length == 0)
          this.appsCols.push({
            dataField: "customColumn3",
            name: "customColumn3",
            caption: this.customColumns.CustomColumn3,
            visible: false,
          });
      }

      if (this.customColumns.CustomColumn4 != null) {
        if (this.appsCols.filter((a) => a.name == "customColumn4").length == 0)
          this.appsCols.push({
            dataField: "customColumn4",
            name: "customColumn4",
            caption: this.customColumns.CustomColumn4,
            visible: false,
          });
      }

      if (this.customColumns.CustomColumn5 != null) {
        if (this.appsCols.filter((a) => a.name == "customColumn5").length == 0)
          this.appsCols.push({
            dataField: "customColumn5",
            name: "customColumn5",
            caption: this.customColumns.CustomColumn5,
            visible: false,
          });
      }

      if (this.customColumns.CustomColumn6 != null) {
        if (this.appsCols.filter((a) => a.name == "customColumn6").length == 0)
          this.appsCols.push({
            dataField: "customColumn6",
            name: "customColumn6",
            caption: this.customColumns.CustomColumn6,
            visible: false,
          });
      }

      if (this.customColumns.CustomColumn7 != null) {
        if (this.appsCols.filter((a) => a.name == "customColumn7").length == 0)
          this.appsCols.push({
            dataField: "customColumn7",
            name: "customColumn7",
            caption: this.customColumns.CustomColumn7,
            visible: false,
          });
      }

      if (this.customColumns.CustomColumn8 != null) {
        if (this.appsCols.filter((a) => a.name == "customColumn8").length == 0)
          this.appsCols.push({
            dataField: "customColumn8",
            name: "customColumn8",
            caption: this.customColumns.CustomColumn8,
            visible: false,
          });
      }

      if (this.customColumns.CustomColumn9 != null) {
        if (this.appsCols.filter((a) => a.name == "customColumn9").length == 0)
          this.appsCols.push({
            dataField: "customColumn9",
            name: "customColumn9",
            caption: this.customColumns.CustomColumn9,
            visible: false,
          });
      }
    },
    getElementTypes() {
      if (this.offlineModeState) return;

      this.elementTypes = this.$store.state.elementTypesPlain;

      /*axios.get('/Element/GetElementTypesPlain')
        .then(response => {
          if (response.status == 200) {
            this.elementTypes = response.data.items;
          }
          else {
            this.$alertMsg(response.data, 1);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })*/
    },
    getElements() {
      var parameter = {
        FilterByCurrentLocation: false,
        ElementTypeId: this.elementType.typeId,
        CoordLat: 0,
        CoordLong: 0,
        CoordAccuracy: 0,
        ListOptions: this.optionsElement,
      };
      if (this.geoLocation != null && this.bGPSFiltering === true) {
        parameter.FilterByCurrentLocation = this.bGPSFiltering;
        parameter.CoordLat = this.geoLocation.coords.latitude;
        parameter.CoordLong = this.geoLocation.coords.longitude;
        parameter.CoordAccuracy = this.geoLocation.coords.accuracy;
      }

      axios
        .post("/Element/GetElements", parameter)
        .then((response) => {
          if (response.status == 200) {
            this.elements = response.data.items;
            this.optionsElement.count = response.data.count;
          }
        })
        .catch((err) => {
          this.$alertMsg(this.$t(err.data));
        });
    },
    getLookups() {
      if (this.offlineModeState) return;

      axios
        .post("/EmployeeApplication/GetLookups")
        .then((resp) => {
          if (resp.status == 200) {
            this.applicationCancelReasons = resp.data.applicationCancelReasons;
            this.applicationStatuses = resp.data.applicationStatuses;
            this.employees = resp.data.employees;
            this.serviceTypes = resp.data.serviceTypes;
            this.stations = resp.data.stations;

            this.billingGroups = resp.data.billingGroups;
            this.prioritys = resp.data.applicationPriorities;
            this.assignToEmployees = resp.data.assignToEmployees;
            this.sourceTypes = resp.data.applicationSourceTypes ?? 0;

            this.billingGroup =
              resp.data.billingGroups.length > 0
                ? resp.data.billingGroups[0].value
                : "";
            this.priority =
              resp.data.applicationPriorities.length > 0
                ? resp.data.applicationPriorities[0].value
                : "";
            this.assignToEmployee =
              resp.data.assignToEmployees.length > 0
                ? resp.data.assignToEmployees[0].value
                : "";
            this.sourceType =
              resp.data.applicationSourceTypes.length > 0
                ? resp.data.applicationSourceTypes[0].value
                : "";

            //this.applicationStation = resp.data.stations.length == 0 ? -1 : resp.data.stations.length == 1 ? resp.data.stations[0].value
            //  : resp.data.stations.filter(a => a.selected).length == 0 ? -1 : resp.data.stations.filter(a => a.selected)[0].value;

            this.orgPosts = resp.data.orgPosts;
            this.applicationOrgPost =
              resp.data.orgPosts.length == 0
                ? -1
                : resp.data.orgPosts.length == 1
                ? resp.data.orgPosts[0].value
                : resp.data.orgPosts.filter((a) => a.selected).length == 0
                ? -1
                : resp.data.orgPosts.filter((a) => a.selected)[0].value;

            this.statuses = resp.data.callerLogStatuses;

            //this.getHierarchyLookups();
            this.getApplications();
            this.getEmployeeApplications();
            this.getCompletedApplications();
            //this.getHierarchyLinks();
          } else this.$alertMsg(resp.data.data.text);
        })
        .catch((err) => {
          this.$alertMsg(err.message);
        });
    },
    getGeneralReports() {
      if (this.offlineModeState) return;

      axios
        .get("/EmployeeApplication/GetGeneralReports")
        .then((response) => {
          if (response.status == 200) {
            this.reports = response.data;
          }
        })
        .catch((err) => {
          err.data == undefined
            ? this.$alertMsg(
                `${this.$t("messages.apiRespondedWithCode")} ${
                  err.response.status
                }`
              )
            : this.$alertMsg(err.data.data.text);
        });
    },
    getQueries() {
      if (this.offlineModeState) return;

      axios
        .get("/CustomQuery/GetQueries?locationId=" + (this.isOm ? "4" : "9"))
        .then((response) => {
          if (response.status == 200) {
            if (response.data == null) this.queries = [];
            else this.queries = response.data;
          }
        })
        .catch((err) => {
          err.data == undefined
            ? this.$alertMsg(
                `${this.$t("messages.apiRespondedWithCode")} ${
                  err.response.status
                }`
              )
            : this.$alertMsg(err.data.data.text);
        });
    },
    printReport(reportId) {
      let parameters = {
        PageSize: this.empAppsOptions.pageSize,
        Page: this.empAppsOptions.page,
        FilterText: this.search,
        From: moment(this.options.from, "DD/MM/YYYY").add(1, "days"),
        To: moment(this.options.to, "DD/MM/YYYY").add(1, "days"),
        AssignedToEmployee: this.empAppsAssignToEmpFilter,
        ApplicationStatus: this.applicationStatus,
        ApplicationTypeModule: this.isOm ? 2 : 1,
        StationId: this.applicationStation != -1 ? this.applicationStation : "",
        ElementId: this.element.id > 0 ? this.element.id : null,
        ElementType:
          this.elementType.typeId > 0 ? this.elementType.typeId : null,
        FilterByLink:
          this.element.id > 0 &&
          this.$store.state.settings.omFilterAppsByWholeBranch
            ? true
            : false,
        //EmployeeId: this.$store.state.userProfile.employeeId,
        ServiceTypeId:
          parseInt(this.serviceType.value) > -1
            ? parseInt(this.serviceType.value)
            : null,
        CallerLogStatusId:
          parseInt(this.status.value) > -1 ? parseInt(this.status.value) : null,
        FilterByApplicationDomain: this.filterByApplicationDomain,
        OrgPostId: this.applicationOrgPost,
      };

      axios
        .post("/EmployeeApplication/CreateApplicationSessionId", parameters)
        .then((response) => {
          if (response.status == 200 && response.data) {
            axios
              .post(
                `/EmployeeApplication/CreateGeneralReport?reportId=${reportId}&sessionId=${response.data}`
              )
              .then((response) => {
                if (response.status == 200) {
                  window.open(response.data, "_blank");
                } else this.$alertMsg(response.data.data.text);
              })
              .catch((err) => {
                return err.data == undefined
                  ? this.$alertMsg(
                      `${this.$t("messages.apiRespondedWithCode")} ${
                        err.response.status
                      }`
                    )
                  : this.$alertMsg(err.data.data.text);
              });
          }
        });
    },
    selectionChanged(info) {},
    clearApplicationsIds() {
      this.selectedApps = [];
      this.offlineAppIds = [];
    },
    clearGridSelections() {
      if (
        this.$refs.applicationsGrid &&
        this.$refs.applicationsGrid.$refs &&
        this.$refs.applicationsGrid.$refs.devExtremeGrid &&
        this.$refs.applicationsGrid.$refs.devExtremeGrid.instance
      ) {
        var g = this.$refs.applicationsGrid.$refs.devExtremeGrid.instance;
        g.clearSelection();
      }
    },

    /* OFFLINE MODE START */

    getOfflineApplications() {
      var applicationIds = [];

      if (this.$refs.applicationsGrid) {
        var g = this.$refs.applicationsGrid.$refs.devExtremeGrid.instance;

        var selectedApps = g.getSelectedRowsData();

        for (var i = 0; i < selectedApps.length; i++) {
          if (
            applicationIds.filter((a) => a == selectedApps[i].applicationId)
              .length == 0
          )
            applicationIds.push(selectedApps[i].applicationId);
        }
      }

      if (this.$refs.employeeApplicationsGrid) {
        var e =
          this.$refs.employeeApplicationsGrid.$refs.devExtremeGrid.instance;
        var empSelectedApps = e.getSelectedRowsData();

        for (var i = 0; i < empSelectedApps.length; i++) {
          if (
            applicationIds.filter((a) => a == empSelectedApps[i].applicationId)
              .length == 0
          )
            applicationIds.push(empSelectedApps[i].applicationId);
        }
      }

      if (applicationIds.length == 0) {
        this.$store.state.csAppsOfflineMode = false;
        this.$alertMsg(this.$t("applications.thereAreNoApplicationsSelected"));
        return;
      }

      var parameters = {
        ApplicationIds: applicationIds,
      };

      this.apps = [];

      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });

      axios
        .post("/OfflineApplication/GetOfflineApplications", parameters)
        .then((response) => {
          console.log("GetOfflineApplications", { ...response.data });
          if (response.status == 200) {
            this.currentTab = "tab-allApps";

            this.apps = response.data.offlineData.appViews.filter(
              (a) => !response.data.notAllowedAppIds.includes(a.applicationId)
            );

            this.options.total = this.apps.length;

            let lngth = this.apps.length;
            let lookups = null;
            for (let i = 0; i < lngth; i++) {
              if (this.apps[i].lastActivityAppKey == 8108) {
                lookups =
                  response.data.offlineData.activityLookups[
                    response.data.offlineData.appKeyToActivityInfo[8108]
                      .activityType
                  ];
              }
            }

            response.data.offlineData.appViews = this.apps;
            const appTypes = response.data.offlineData.appTypes;
            const appTypeActivities =
              response.data.offlineData.appTypeActivities;

            delete response.data.offlineData.appTypes;
            delete response.data.offlineData.appTypeActivities;

            this.$store.commit("setOfflineApplicationsData", {
              data: response.data.offlineData,
            });

            this.$store.commit("setNewOfflineApplicationsData", {
              appTypes,
              appTypeActivities,
            });

            let noAllowedApplications = "";
            if (response.data.notAllowedAppIds.length > 0) {
              for (let i = 0; i < response.data.notAllowedAppIds.length; i++) {
                noAllowedApplications +=
                  (i == 0 ? "" : " ,") +
                  response.data.notAllowedAppIds[i].toString();
              }

              response.data.notAllowedAppIds.length == 1
                ? this.$alertMsg(
                    this.$t(
                      "applications.applicationsAreNotInRightStateForOffline"
                    ) +
                      " " +
                      noAllowedApplications
                  )
                : this.$alertMsg(
                    this.$t(
                      "applications.applicationIsNotInRightStateForOffline"
                    ) +
                      " " +
                      noAllowedApplications
                  );
            }

            this.clearGridSelections();
          }
        })
        .catch((err) =>
          err.data == undefined
            ? this.$alertMsg(
                `${this.$t("messages.apiRespondedWithCode")} ${
                  err.response.status
                }`
              )
            : this.$alertMsg(err.data.data.text)
        )
        .finally(() => loader.hide());
    },
    getOfflineAllRecords() {
      this.$store.state.csLocalDB
        .allDocs({
          include_docs: true,
        })
        .then((result) => {
          this.offlineSavedApps = [];

          result.rows.forEach((item) => {
            //if (this.offlineSavedApps.filter(a => a.applicationId == item.doc.applicationId).length == 0)
            this.offlineSavedApps.push(item.doc);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeSyncRecordConfirm(syncRec) {
      this.syncRecord = syncRec;
      this.removeSyncRecordConfirmation = true;
    },
    removeSyncRecord() {
      this.$store.state.csLocalDB
        .remove(this.syncRecord)
        .then((resultRemove) => {
          this.removeSyncRecordConfirmation = false;
          this.getOfflineAllRecords();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    syncParameters(all, app) {
      let parameters = {
        OfflineApplications: [],
      };

      if (all == false) {
        let acts = [];

        for (let a = 0; a < app.activities.length; a++) {
          acts.push({
            AppKey: app.activities[a].appKey,
            Data: app.activities[a].activity,
            CustomFieldValues: app.activities[a].customFieldValues,
            IsCompleted:
              app.activities.length > 1 && a != app.activities.length - 1
                ? true
                : false,
            Location:
              app.activities[a].location.CoordLat === 0 &&
              app.activities[a].location.CoordLong === 0
                ? null
                : app.activities[a].location,
          });
        }

        let ap = {
          ApplicationId: app.applicationId,
          PostApplication: false,
          Activities: acts,
        };

        parameters.OfflineApplications.push(ap);
      } else {
        let acts = [];
        let ap = {};

        for (let i = 0; i < this.offlineSavedApps.length; i++) {
          acts = [];
          ap = {};

          for (let a = 0; a < this.offlineSavedApps[i].activities.length; a++) {
            acts.push({
              AppKey: this.offlineSavedApps[i].activities[a].appKey,
              Data: this.offlineSavedApps[i].activities[a].activity,
              CustomFieldValues:
                this.offlineSavedApps[i].activities[a].customFieldValues,
              IsCompleted:
                this.offlineSavedApps[i].activities.length > 1 &&
                a != this.offlineSavedApps[i].activities.length - 1
                  ? true
                  : false,
              Location:
                app.activities[a].location.CoordLat === 0 &&
                app.activities[a].location.CoordLong === 0
                  ? null
                  : app.activities[a].location,
            });
          }

          ap = {
            ApplicationId: this.offlineSavedApps[i].applicationId,
            PostApplication: false,
            Activities: acts,
          };

          parameters.OfflineApplications.push(ap);
        }
      }

      return parameters;
    },
    syncRecords(all, syncRec) {
      let parameter = this.syncParameters(all, syncRec);

      this.$store.state.notifier.asyncBlock(
        axios.post("/OfflineApplication/ProcessApplications/", parameter),
        (resp) => {
          if (resp.status == 200) {
            this.$alertMsg(this.$t("common.SyncRecordSuccessful"), 2);

            for (let i = 0; i < parameter.OfflineApplications.length; i++) {
              this.syncRecord = this.offlineSavedApps.filter(
                (a) =>
                  a.applicationId ==
                  parameter.OfflineApplications[i].ApplicationId
              )[0];
              this.removeSyncRecord();
            }
          } else this.$alertMsg(resp.data.data.text);
        },
        (err) => {
          this.$alertMsg(err.response.data);
        },
        "Syncing record to backend"
      );
    },
    /* OFFLINE MODE END */

    getHierarchyLookups() {
      axios
        .get("Element/GetHierarchyLookups")
        .then((response) => {
          //          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getHierarchyLinks() {
      return;
      //if (this.$store.state.hierarchyLinksLoaded)
      //  return;

      //axios.get('Element/GetHierarchyLinks?elementTypeId=-1')
      //  .then(response => {
      //    console.log(response);
      //    this.hierarchyLinks = response.data;
      //    this.populateTree();

      //  })
      //  .catch(error => {
      //    console.log(error);
      //  });
    },
    mapChildren(Children) {
      return Children.map((a, index) => {
        return {
          text: a.Name,
          data: {
            id: index,
            elementId: a.ElementId,
            elementTypeId: a.ElementTypeId,
          },
          id: index,
          children: this.mapChildren(a.Children),
          state: {
            selected: false,
            selectable: true,
            checked: false,
            expanded: this.bExpandNodes,
            disabled: false,
            visible: true,
            indeterminate: false,
            matched: false,
            editable: true,
            dragging: false,
            draggable: true,
            dropable: true,
          },
        };
      });
    },
    createNodeTree(assetNode) {
      this.treeIdx++;

      var node = {
        id: this.treeIdx,
        text: assetNode.Name,
        data: {
          id: this.getUniqueId(),
          elementId: assetNode.ElementId,
          elementTypeId: assetNode.ElementTypeId,
        },
        children: [],
        state: {
          selected: false,
          selectable: true,
          checked: false,
          expanded: this.bExpandNodes,
          disabled: false,
          visible: true,
          indeterminate: false,
          matched: false,
          editable: true,
          dragging: false,
          draggable: true,
          dropable: true,
        },
      };
      assetNode.Children.forEach((item) => {
        node.children.push(this.createNodeTree(item));
      });

      return node;
    },
    onNodeSelected(node) {
      this.getApplications();
    },
    populateTree() {
      this.iCurrentCount = 0;
      this.hierarchyLinksItems = [];
      this.hierarchyLinks.forEach((item) => {
        this.hierarchyLinksItems.push(this.createNodeTree(item));
      });
      this.HierarchyKey++;

      //console.log('this.HierarchyKey', this.HierarchyKey);
    },
    getUniqueId() {
      return this.iCurrentCount++;
    },
    showHideHierarchyTree() {
      import("../../common/hierarchyLinks/hierarchyLinks").then(() => {
        this.HierarchyLinksCompLoaded = true;
      });

      this.appsCol.classList.toggle("fullWidth");
      this.appsCol.classList.toggle("gridWidth");

      this.treeCol.classList.toggle("showCol");
      this.treeCol.classList.toggle("treeWidth");
      this.treeCol.classList.toggle("displayNode");

      if (
        !this.treeCol.classList.contains("displayNode") &&
        (this.element.id != 0 || this.elementType.typeId != 0)
      ) {
        this.element.id = 0;
        this.elementType.typeId = 0;

        this.getApplications();
      }
    },
    nodeClicked(node) {
      console.log(node);
      if (node.selected) {
        this.selectedNode = node;
        this.element.id = node.ElementId;
        this.elementType.typeId = node.ElementTypeId;
      } else {
        this.selectedNode = null;
        this.element.id = 0;
        this.elementType.typeId = 0;
      }

      this.getApplications();
      this.getEmployeeApplications();
      this.getCompletedApplications();

      //if (this.selectedNode) {
      //  if (this.selectedNode.ElementId == node.ElementId) {
      //    if (document.querySelector('.selected'))
      //      document.querySelector('.selected').classList.remove('selected');

      //    this.selectedNode = null;
      //    this.element.id = 0;
      //    this.elementType.typeId = 0;
      //    this.getApplications();
      //  } else {
      //    this.selectedNode = node;
      //    this.element.id = node.ElementId;
      //    this.elementType.typeId = node.ElementTypeId;
      //    this.getApplications();
      //  }
      //}
      //else {
      //  this.selectedNode = node;
      //  this.element.id = node.ElementId;
      //  this.elementType.typeId = node.ElementTypeId;
      //  this.getApplications();
      //}
    },
    getEmployeeApplications(isSearch, scrollToApps) {
      let parameters;
      if (!isSearch) {
        parameters = {
          PageSize: this.empAppsOptions.pageSize,
          Page: this.empAppsOptions.page,
          FilterText: "",
          From: null,
          To: null,
          AssignedToEmployee: this.empAppsAssignToEmpFilter,
          ApplicationStatus: 1,
          ApplicationTypeModule: this.isOm ? 2 : 1,
          StationId: "",
          ElementId: this.element.id > 0 ? this.element.id : null,
          ElementType:
            this.elementType.typeId > 0 ? this.elementType.typeId : null,
          FilterByLink:
            this.element.id > 0 &&
            this.$store.state.settings.omFilterAppsByWholeBranch
              ? true
              : false,
          //EmployeeId: this.$store.state.userProfile.employeeId,
          ServiceTypeId: null,
          CallerLogStatusId: null,
          FilterByApplicationDomain: false,
          OrgPostId:
            this.$store.state.userProfile.orgPostId &&
            this.$store.state.userProfile.orgPostId > -1
              ? this.$store.state.userProfile.orgPostId
              : null,

          BillingGroup: this.showFilters ? this.billingGroup : null,
          PriorityId: this.showFilters ? this.priority : null,
          AssignedEmployeeId: this.showFilters
            ? this.assignToEmployee ?? -1
            : -1,
          ApplicationSourceType: this.showFilters ? this.sourceType ?? 0 : 0,
        };
      } else {
        parameters = {
          PageSize: this.empAppsOptions.pageSize,
          Page: this.empAppsOptions.page,
          FilterText: this.search,
          From: moment(this.options.from, "DD/MM/YYYY").add(1, "days"),
          To: moment(this.options.to, "DD/MM/YYYY").add(1, "days"),
          AssignedToEmployee: this.empAppsAssignToEmpFilter,
          ApplicationStatus: this.applicationStatus,
          ApplicationTypeModule: this.isOm ? 2 : 1,
          StationId:
            this.applicationStation != -1 ? this.applicationStation : "",
          ElementId: this.element.id > 0 ? this.element.id : null,
          ElementType:
            this.elementType.typeId > 0 ? this.elementType.typeId : null,
          FilterByLink:
            this.element.id > 0 &&
            this.$store.state.settings.omFilterAppsByWholeBranch
              ? true
              : false,
          //EmployeeId: this.$store.state.userProfile.employeeId,
          ServiceTypeId:
            parseInt(this.serviceType.value) > -1
              ? parseInt(this.serviceType.value)
              : null,
          CallerLogStatusId:
            parseInt(this.status.value) > -1
              ? parseInt(this.status.value)
              : null,
          FilterByApplicationDomain: this.filterByApplicationDomain,
          OrgPostId:
            this.applicationOrgPost && this.applicationOrgPost > -1
              ? this.applicationOrgPost
              : null,

          BillingGroup: this.showFilters ? this.billingGroup : null,
          PriorityId: this.showFilters ? this.priority : null,
          AssignedEmployeeId: this.showFilters
            ? this.assignToEmployee ?? -1
            : -1,
          ApplicationSourceType: this.showFilters ? this.sourceType ?? 0 : 0,
        };
      }

      axios
        .post("/EmployeeApplication/GetApplications", parameters)
        .then((response) => {
          if (response.status == 200) {
            response.data.items.forEach((item) => {
              item.issueTime =
                item.date != null && item.date != ""
                  ? moment(item.date).format("HH:mm:ss")
                  : "";
              item.issueDate = item.date;
              item.lastEditTime =
                item.lastEditDate != null && item.lastEditDate != ""
                  ? moment(item.lastEditDate).format("HH:mm:ss")
                  : "";
              item.assignTime =
                item.assignDate != null && item.assignDate != ""
                  ? moment(item.assignDate).format("HH:mm:ss")
                  : "";
            });

            this.employeeApps = response.data.items.sort(
              this.dateIdCompareDesc
            );

            //this.customColumns = response.data.customColumns;
            //this.firstLoad = false;
            this.empAppsOptions.total = response.data.itemsCount;
            this.totalEmpAppsRow = response.data.itemsCount;

            //this.clearGridSelections();
            //this.addCustomColumns();

            if (scrollToApps) this.$scrollToElement("applications_grids");

            setTimeout(() => {
              if (this.$refs.employeeApplicationsGrid) {
                this.$refs.employeeApplicationsGrid.resetColumns();
              }
            }, 10000);
          }
        })
        .catch((err) =>
          err.data == undefined
            ? this.$alertMsg(
                `${this.$t("messages.apiRespondedWithCode")} ${err}`
              )
            : this.$alertMsg(err.data.data.text)
        );
    },
    changeTab(e) {
      this.currentTab = e;

      this.saveToLocal("_selected_applications_tab", e);

      //if (e == 'tab-empApps' && this.showFilters) {
      //  this.showFilters = false;
      //}
    },
    empAppsPageChange(pInfo) {
      if (
        pInfo.pageNumber == this.empAppsOptions.page &&
        pInfo.pageSize == this.empAppsOptions.pageSize
      )
        return;

      for (var i = 0; i < this.selectedApps.length; i++) {
        if (
          this.offlineAppIds.filter(
            (a) => a == this.selectedApps[i].applicationId
          ).length == 0
        )
          this.offlineAppIds.push(this.selectedApps[i].applicationId);
      }

      this.empAppsOptions.page = pInfo.pageNumber;
      this.empAppsOptions.pageSize = pInfo.pageSize;

      this.getEmployeeApplications();
    },
    getCompletedApplications(scrollToApps) {
      var parameters = {
        PageSize: this.CompletedAppsOptions.pageSize,
        Page: this.CompletedAppsOptions.page,
        FilterText: "",
        From: this.showFilters
          ? moment(this.options.from, "DD/MM/YYYY").add(1, "days")
          : null,
        To: this.showFilters
          ? moment(this.options.to, "DD/MM/YYYY").add(1, "days")
          : null,
        AssignedToEmployee: false,
        ApplicationStatus: 2,
        ApplicationTypeModule: this.isOm ? 2 : 1,
        StationId: this.applicationStation != -1 ? this.applicationStation : "",
        ElementId: this.element.id > 0 ? this.element.id : null,
        ElementType:
          this.elementType.typeId > 0 ? this.elementType.typeId : null,
        FilterByLink:
          this.element.id > 0 &&
          this.$store.state.settings.omFilterAppsByWholeBranch
            ? true
            : false,
        //EmployeeId: this.$store.state.userProfile.employeeId,
        ServiceTypeId: null,
        CallerLogStatusId: null,
        FilterByApplicationDomain: false,
        OrgPostId:
          this.applicationOrgPost && this.applicationOrgPost > -1
            ? this.applicationOrgPost
            : null,
        DisableOrgPostAccessCheck: true,
      };

      axios
        .post("/EmployeeApplication/GetApplications", parameters)
        .then((response) => {
          if (response.status == 200) {
            response.data.items.forEach((item) => {
              item.issueTime =
                item.date != null && item.date != ""
                  ? moment(item.date).format("HH:mm:ss")
                  : "";
              item.issueDate = item.date; // != null && item.date != '' ? moment(item.date).format('DD/MM/YYYY') : ''
              item.lastEditTime =
                item.lastEditDate != null && item.lastEditDate != ""
                  ? moment(item.lastEditDate).format("HH:mm:ss")
                  : "";
              item.assignTime =
                item.assignDate != null && item.assignDate != ""
                  ? moment(item.assignDate).format("HH:mm:ss")
                  : "";
            });

            this.completedApps = response.data.items.sort(
              this.dateIdCompareDesc
            );
            //this.customColumns = response.data.customColumns;
            //this.firstLoad = false;
            this.CompletedAppsOptions.total = response.data.itemsCount;
            this.totalCompletedRow = response.data.itemsCount;

            //this.clearGridSelections();
            //this.addCustomColumns();

            if (scrollToApps) this.$scrollToElement("applications_grids");

            setTimeout(() => {
              if (this.$refs.completedApplicationsGrid)
                this.$refs.completedApplicationsGrid.resetColumns();
            }, 10000);
          }
        })
        .catch((err) =>
          err.data == undefined
            ? this.$alertMsg(
                `${this.$t("messages.apiRespondedWithCode")} ${
                  err.response.status
                }`
              )
            : this.$alertMsg(err.data.data.text)
        );
    },
    completedAppsPageChange(pInfo) {
      if (
        pInfo.pageNumber == this.CompletedAppsOptions.page &&
        pInfo.pageSize == this.CompletedAppsOptions.pageSize
      )
        return;

      for (var i = 0; i < this.selectedApps.length; i++) {
        if (
          this.offlineAppIds.filter(
            (a) => a == this.selectedApps[i].applicationId
          ).length == 0
        )
          this.offlineAppIds.push(this.selectedApps[i].applicationId);
      }

      this.CompletedAppsOptions.page = pInfo.pageNumber;
      this.CompletedAppsOptions.pageSize = pInfo.pageSize;

      this.getCompletedApplications();
    },
    filterApplications() {
      if (this.currentTab == "tab-allApps") this.getApplications(true);
      else if (this.currentTab == "tab-completedApps")
        this.getCompletedApplications(true);
      else if (this.currentTab == "tab-empApps")
        this.getEmployeeApplications(true);
    },
    getEmployeeStation(station) {
      if (station && station >= 0) {
        this.employeeStationId = station;
      } else {
        let prof = this.$store.getters.getUserProfile;
        if (prof && prof.employeeStationId && prof.employeeStationId >= 0)
          this.employeeStationId = prof.employeeStationId;
      }

      this.$forceUpdate();
    },
  },
};
